import React, { useEffect, useState } from 'react';
import { CheckCircle2, Clock, Download, ShieldCheck, Zap, BookOpen, Users, Star, ArrowRight, FileText, Layout, Video, ChevronLeft, ChevronRight } from 'lucide-react';
const MAIN_PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/1SkW4WMUthKBafSP3e6Jvi/kit_png_transpa.png';
const HERO_BG_IMG = 'https://cdn.magicpatterns.com/uploads/iNgfP8HzejpRnqSv2z1RyE/5e003e53-3bc5-465d-8b8c-d89151b5c4e1.png';
const PACK_PRO_IMG = 'https://cdn.magicpatterns.com/uploads/x3nZ6sUk6SUwH45mASULAZ/8d136c42-8545-4a7c-806c-f2c7d28e12d0.png';
const BONUS_1_IMG = 'https://cdn.magicpatterns.com/uploads/8UF4T8a8ux6w6a78rTjFbU/bonus_1.png';
const BONUS_2_IMG = 'https://cdn.magicpatterns.com/uploads/obxYyFAn4peC59MZRneAs5/bonus_2.png';
const BONUS_3_IMG = 'https://cdn.magicpatterns.com/uploads/jddnkDdhBkqj9GkoU6Ssmg/BONUS_EXCLUSIVO_3_.png';
const BONUS_4_IMG = 'https://cdn.magicpatterns.com/uploads/5jt623bYxcMZyVnZHwJX6P/BONUS_4.png';
const BONUSES_BG_IMG = 'https://cdn.magicpatterns.com/uploads/cCHYyugcYRohLDmd1XWfCF/193274ec-cb8a-4915-9197-2c14563ce9c7.png';
const PREVIEW_IMGS = ['https://cdn.magicpatterns.com/uploads/mQoCLQv39go8F8N7DFfDLw/pag_.png', 'https://cdn.magicpatterns.com/uploads/rvJhfJkcwYyFkNLLxnTk3Z/pagina_1.png', 'https://cdn.magicpatterns.com/uploads/c5dhkTP2jMrSQEFhgWSim2/pagina_2.png', 'https://cdn.magicpatterns.com/uploads/mkRGZZZuZFjFCYvHXt5f6E/pg_2.png', 'https://cdn.magicpatterns.com/uploads/hafYeCk2rAAakNmWJX2BYm/pag_5.png', 'https://cdn.magicpatterns.com/uploads/k6c6PErk6GcDQstGp926Xh/pag_6.png', 'https://cdn.magicpatterns.com/uploads/8HWYPUE3sdmYuFmEv6yEWd/pag_7.png', 'https://cdn.magicpatterns.com/uploads/hcS3dY3KQ4YR1nhECrT2Aa/9.png', 'https://cdn.magicpatterns.com/uploads/7287RKYFwFxjNNd69QATda/Captura_de_pantalla_2026-02-21_131324.png'];
const CHECKOUT_NORMAL = 'https://checkout.kitspremium.online/checkouts/cn/hWN9RiDut1GPuD6mfK15NvH8/es-ar?_r=AQABzTly_J9SL4xRiTasoI8KKOylC2Qm_MFFQ2ayFBGsQ-8&preview_theme_id=138042802263';
const CHECKOUT_SUPER = 'https://checkout.kitspremium.online/checkouts/cn/hWN9RhuXmLhHcqrvrOrQjXE2/es-ar?_r=AQABWJEtSDNZdWBJEO47ezDCfJdxfR19_1yHhSjr6G7-xf4&preview_theme_id=138042802263';
export function SalesPage() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 3
  });
  const [previewIdx, setPreviewIdx] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 0,
          minutes: 14,
          seconds: 0
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const prevPreview = () => setPreviewIdx(i => i === 0 ? PREVIEW_IMGS.length - 1 : i - 1);
  const nextPreview = () => setPreviewIdx(i => i === PREVIEW_IMGS.length - 1 ? 0 : i + 1);
  return <div className="w-full overflow-x-hidden bg-[#F8FAFC]" data-id="element-15">
      {/* Top Bar */}
      <div className="bg-[#1E3A8A] text-white text-center py-2 text-sm font-medium flex justify-center items-center gap-2 flex-wrap px-4" data-id="element-16">
        <Clock className="w-4 h-4" data-id="element-17" />
        <span data-id="element-18">
          OFERTA TERMINA EN: {String(timeLeft.hours).padStart(2, '0')}:
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </div>

      {/* Hero Section — with background image */}
      <header className="relative py-12 md:py-16 px-4 text-center" style={{
      backgroundImage: `url(${HERO_BG_IMG})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-19">
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/[0.58]" data-id="element-20" />

        <div className="relative z-10 max-w-5xl mx-auto" data-id="element-21">
          <div className="inline-flex items-center gap-2 text-white/80 font-bold uppercase tracking-wider text-xs mb-3" data-id="element-22">
            <Users className="w-3 h-3" data-id="element-23" />
            Para Docentes de Comunicación y Oratoria
          </div>

          <h1 className="text-2xl md:text-4xl font-extrabold text-white mb-4 leading-tight max-w-3xl mx-auto drop-shadow-lg" data-id="element-24">
            Organizá todo tu año de Comunicación y{' '}
            <span className="text-[#D4A017]" data-id="element-25">
              ahorrá hasta 12 meses de planificación
            </span>{' '}
            con el Mega Pack Oratoria Resuelta
          </h1>

          <div className="relative mx-auto mb-5 cursor-pointer" style={{
          maxWidth: '340px'
        }} onClick={scrollToPricing} data-id="element-26">
            <style data-id="element-27">{`
              @keyframes float {
                0%, 100% { transform: translateY(0px); }
                50% { transform: translateY(-8px); }
              }
            `}</style>
            <img src={MAIN_PRODUCT_IMG} alt="Megapack Comunicación y Oratoria" className="w-full h-auto hover:scale-105 transition-transform duration-500" style={{
            maxHeight: '45vh',
            objectFit: 'contain',
            animation: 'float 4s ease-in-out infinite',
            filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.5))'
          }} data-id="element-28" />
          </div>

          <p className="text-white/90 text-sm max-w-xl mx-auto mb-5" data-id="element-29">
            Sistema completo de clases, actividades y proyectos de oratoria
            listos para usar.{' '}
            <strong data-id="element-30">Todo tu año resuelto (todos los niveles)</strong>
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-5" data-id="element-31">
            <button onClick={scrollToPricing} className="bg-[#D4A017] hover:bg-[#B8860B] text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 w-full sm:w-auto max-w-sm" data-id="element-32">
              <span data-id="element-33">👉</span> SÍ, QUIERO ACCESO INMEDIATO{' '}
              <ArrowRight className="w-5 h-5" data-id="element-34" />
            </button>
            <button onClick={scrollToPricing} className="border-2 border-white/60 text-white text-sm font-bold py-3 px-6 rounded-full hover:bg-white/10 transition-all flex items-center gap-2" data-id="element-35">
              Más información ↓
            </button>
          </div>

          <div className="flex flex-wrap justify-center gap-3 text-xs text-white/70" data-id="element-36">
            <span className="flex items-center gap-1" data-id="element-37">
              <ShieldCheck className="w-3 h-3" data-id="element-38" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-39">
              <Download className="w-3 h-3" data-id="element-40" /> Descarga inmediata
            </span>
            <span className="flex items-center gap-1" data-id="element-41">
              <CheckCircle2 className="w-3 h-3" data-id="element-42" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-43">
              <Users className="w-3 h-3" data-id="element-44" /> Acceso de por vida
            </span>
          </div>
        </div>
      </header>

      {/* Pain Points */}
      <section className="bg-[#F8FAFC] py-12 px-4 border-t border-gray-100" data-id="element-45">
        <div className="max-w-4xl mx-auto" data-id="element-46">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#1E3A8A] mb-8" data-id="element-47">
            Si enseñás Comunicación, esto te va a{' '}
            <span className="text-[#1E3A8A]" data-id="element-48">sonar familiar...</span>
          </h2>
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-49">
            <p className="text-base text-[#0F172A] mb-4" data-id="element-50">
              Llegás del trabajo <strong data-id="element-51">agotado/a</strong> y tenés que
              planificar. Horas buscando proyectos, diseñando experiencias,
              armando evaluaciones...
            </p>
            <div className="bg-amber-50 border-l-4 border-[#D4A017] p-4 rounded-r-lg" data-id="element-52">
              <p className="text-[#0F172A] font-medium" data-id="element-53">
                <strong data-id="element-54">No es falta de capacidad.</strong> Es que te falta un{' '}
                <strong data-id="element-55">sistema integral</strong> que te sostenga todo el año.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution */}
      <section className="py-12 px-4 text-center bg-white" data-id="element-56">
        <span className="bg-[#D4A017] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-widest" data-id="element-57">
          La Solución
        </span>
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1E3A8A] mt-4 mb-3" data-id="element-58">
          MEGA PACK{' '}
          <span className="text-[#2563EB]" data-id="element-59">COMUNICACIÓN Y ORATORIA™</span>
        </h2>
        <p className="text-lg text-[#0F172A] mb-10" data-id="element-60">
          Sistema completo de proyectos, experiencias y evaluaciones{' '}
          <strong data-id="element-61">ya probadas en aula</strong>.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto" data-id="element-62">
          {[{
          icon: CheckCircle2,
          label: 'Listo'
        }, {
          icon: Zap,
          label: 'Probado'
        }, {
          icon: Layout,
          label: 'Organizado'
        }, {
          icon: Star,
          label: 'Usable'
        }].map((item, i) => <div key={i} className="bg-blue-50 p-5 rounded-xl flex flex-col items-center gap-2" data-id="element-63">
              <item.icon className="w-7 h-7 text-[#D4A017]" data-id="element-64" />
              <h3 className="font-bold text-[#D4A017] text-sm" data-id="element-65">{item.label}</h3>
            </div>)}
        </div>
      </section>

      {/* What's Included */}
      <section className="py-10 px-4 max-w-4xl mx-auto" data-id="element-66">
        <h3 className="text-2xl font-bold text-center mb-2" data-id="element-67">
          Lo que incluye el sistema
        </h3>
        <p className="text-center text-gray-500 text-sm mb-8" data-id="element-68">
          Todo organizado. Todo coherente. Todo aplicable.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-69">
          {[{
          icon: BookOpen,
          text: 'Programa completo de 6 años'
        }, {
          icon: CheckCircle2,
          text: 'Objetivos por nivel'
        }, {
          icon: Layout,
          text: 'Proyectos anuales listos'
        }, {
          icon: Star,
          text: 'Criterios de evaluación claros'
        }, {
          icon: FileText,
          text: 'Instrumentos listos para aplicar'
        }, {
          icon: CheckCircle2,
          text: 'Planillas y rúbricas'
        }, {
          icon: FileText,
          text: '200+ fichas editables'
        }, {
          icon: Zap,
          text: 'Estructura para feria escolar'
        }].map((item, i) => <div key={i} className="flex items-center gap-3 p-3 bg-white border border-gray-100 rounded-lg shadow-sm" data-id="element-70">
              <div className="bg-blue-50 p-2 rounded-lg shrink-0" data-id="element-71">
                <item.icon className="w-4 h-4 text-[#2563EB]" data-id="element-72" />
              </div>
              <span className="text-[#0F172A] font-medium text-sm" data-id="element-73">
                {item.text}
              </span>
            </div>)}
        </div>
      </section>

      {/* Results Section */}
      <section className="py-12 px-4 bg-white" data-id="element-74">
        <h2 className="text-2xl font-bold text-center text-[#1E3A8A] mb-8" data-id="element-75">
          Resultados que <span className="text-[#D4A017]" data-id="element-76">transforman</span>
        </h2>
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-6" data-id="element-77">
          <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-[#D4A017]/20" data-id="element-78">
            <div className="flex items-center gap-3 mb-4" data-id="element-79">
              <div className="bg-[#D4A017] p-2 rounded-lg text-white" data-id="element-80">
                <Users className="w-5 h-5" data-id="element-81" />
              </div>
              <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-82">
                Para tus Estudiantes 🎓
              </h3>
            </div>
            <ul className="space-y-2" data-id="element-83">
              {['Pierden el miedo a hablar en público', 'Argumentan con lógica y evidencia', 'Mejoran su expresión corporal', 'Participan activamente en clase'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-84">
                  <CheckCircle2 className="w-4 h-4 text-[#D4A017] shrink-0 mt-0.5" data-id="element-85" />
                  <span className="text-[#0F172A]" data-id="element-86">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-[#D4A017]/20" data-id="element-87">
            <div className="flex items-center gap-3 mb-4" data-id="element-88">
              <div className="bg-[#D4A017] p-2 rounded-lg text-white" data-id="element-89">
                <Star className="w-5 h-5" data-id="element-90" />
              </div>
              <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-91">
                Para Vos como Docente 👩‍🏫
              </h3>
            </div>
            <ul className="space-y-2" data-id="element-92">
              {['Ahorrás horas de planificación semanal', 'Tenés rúbricas listas para evaluar', 'Clases dinámicas sin estrés', 'Reconocimiento de directivos y padres'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-93">
                  <CheckCircle2 className="w-4 h-4 text-[#D4A017] shrink-0 mt-0.5" data-id="element-94" />
                  <span className="text-[#0F172A]" data-id="element-95">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="text-center mt-8" data-id="element-96">
          <button onClick={scrollToPricing} className="bg-[#D4A017] hover:bg-[#B8860B] text-white text-lg font-bold py-3 px-10 rounded-full shadow-lg transition-all transform hover:-translate-y-1 inline-flex items-center gap-2" data-id="element-97">
            <span data-id="element-98">👉</span> QUIERO LOGRARLO <ArrowRight className="w-5 h-5" data-id="element-99" />
          </button>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="relative py-14 px-4 overflow-hidden" data-id="element-100">
        {/* Background image with 50% opacity and blur */}
        <div className="absolute inset-0" data-id="element-101">
          <img src={BONUSES_BG_IMG} alt="" className="w-full h-full object-cover" style={{
          opacity: 0.5,
          filter: 'blur(3px)'
        }} data-id="element-102" />
          <div className="absolute inset-0 bg-[#0F172A]/60" data-id="element-103" />
        </div>

        <div className="relative z-10" data-id="element-104">
          <div className="text-center mb-10" data-id="element-105">
            <span className="bg-yellow-500 text-black px-6 py-2 rounded-full text-sm font-black uppercase tracking-widest inline-flex items-center gap-2" data-id="element-106">
              🎁 BONOS GRATIS HOY
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-5" data-id="element-107">
              Te llevás{' '}
              <span className="text-[#2563EB]" data-id="element-108">4 bonos exclusivos</span>
            </h2>
            <p className="text-yellow-400 font-bold mt-2 text-base" data-id="element-109">
              ¡GRATIS por el día de hoy!
            </p>
          </div>
          <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-110">
            {[{
            img: BONUS_1_IMG,
            label: 'BONO 1',
            title: 'Banco de Rúbricas Defendibles (Editable)',
            desc: 'Un paquete de rúbricas listas para usar y adaptar. Evaluá con criterios claros y profesionales.'
          }, {
            img: BONUS_2_IMG,
            label: 'BONO 2',
            title: 'Plantillas de Informes de Desempeño',
            desc: 'Convertí tu evaluación en un documento formal y defendible. Plantillas editables.'
          }, {
            img: BONUS_3_IMG,
            label: 'BONO EXCLUSIVO 3',
            title: 'Banco de Proyectos + 5 Cuadernillos Técnicos',
            desc: 'Proyectos institucionales completos y cuadernillos técnicos aplicables en clase.'
          }, {
            img: BONUS_4_IMG,
            label: 'BONO 4',
            title: 'Calendario Estratégico de Implementación (12 Meses)',
            desc: 'No solo sabés qué enseñar. Sabés cuándo y cómo. Planificación anual lista para ejecutar.'
          }].map((bonus, i) => <div key={i} className="bg-white/5 border border-white/10 p-4 rounded-xl flex flex-col items-center cursor-pointer hover:bg-white/10 transition-colors backdrop-blur-sm" style={{
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
          }} onClick={scrollToPricing} data-id="element-111">
                <div className="flex justify-between items-center w-full mb-3" data-id="element-112">
                  <span className="bg-[#2563EB] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-113">
                    {bonus.label}
                  </span>
                  <span className="bg-yellow-500 text-black text-xs font-black px-3 py-1 rounded-full" data-id="element-114">
                    🎁 GRATIS
                  </span>
                </div>
                <img src={bonus.img} alt={bonus.title} className="w-full max-w-[240px] h-auto rounded-lg mb-3" style={{
              filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.4))'
            }} data-id="element-115" />
                <h3 className="font-bold text-base text-white text-center mb-1" data-id="element-116">
                  {bonus.title}
                </h3>
                <p className="text-xs text-gray-400 text-center" data-id="element-117">
                  {bonus.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== PRICING SECTION — Two-tier structure ===== */}
      <section id="compra" className="py-14 px-4 bg-[#0F172A]" data-id="element-118">
        <div className="text-center mb-10" data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white" data-id="element-120">
            OFERTA ESPECIAL
          </h2>
          <div className="flex justify-center items-center gap-2 mt-3" data-id="element-121">
            <Clock className="w-4 h-4 text-yellow-400" data-id="element-122" />
            <span className="text-yellow-400 font-bold text-sm" data-id="element-123">
              OFERTA TERMINA EN: {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
        </div>

        <div className="max-w-lg mx-auto flex flex-col gap-8" data-id="element-124">
          {/* Pack 1: Kit Completo Comunicación y Oratoria */}
          <div className="bg-[#1E3A8A] rounded-2xl overflow-hidden border border-white/10 shadow-xl flex flex-col" data-id="element-125">
            <div className="bg-[#2563EB] text-white text-center py-2 text-xs font-black uppercase tracking-widest" data-id="element-126">
              ⭐ EL KIT MÁS VENDIDO
            </div>
            <div className="p-6 flex flex-col" data-id="element-127">
              <h3 className="text-xl font-black text-white text-center mb-1" data-id="element-128">
                Kit Completo Comunicación y Oratoria
              </h3>

              <div className="text-center mb-4" data-id="element-129">
                <p className="text-white/50 line-through text-sm" data-id="element-130">$49.990</p>
                <div className="flex justify-center items-baseline gap-1" data-id="element-131">
                  <span className="text-4xl font-black text-[#D4A017]" data-id="element-132">
                    $19.990
                  </span>
                  <span className="text-white/60 text-sm" data-id="element-133">ARS</span>
                </div>
              </div>

              <div className="space-y-2 mb-4" data-id="element-134">
                {['Pack Completo de Comunicación y Oratoria', '200+ fichas editables', 'Proyectos anuales listos', 'Planillas y rúbricas', 'Descarga inmediata en PDF', '4 Bonos incluidos GRATIS'].map((item, i) => <div key={i} className="flex items-center gap-2 text-sm text-white/90" data-id="element-135">
                    <CheckCircle2 className="w-4 h-4 text-[#D4A017] shrink-0" data-id="element-136" />
                    <span data-id="element-137">{item}</span>
                  </div>)}
              </div>

              <a href={CHECKOUT_NORMAL} target="_blank" rel="noopener noreferrer" className="block w-full bg-[#D4A017] hover:bg-[#B8860B] text-white text-lg font-black py-3 rounded-lg shadow-lg text-center transition-all transform hover:-translate-y-1" data-id="element-138">
                ✅ SÍ, QUIERO LA OFERTA →
              </a>

              <div className="flex justify-center items-center gap-3 text-white/40 text-xs mt-3" data-id="element-139">
                <span data-id="element-140">VISA</span>
                <span data-id="element-141">Mastercard</span>
                <span data-id="element-142">MercadoPago</span>
              </div>
            </div>
          </div>

          {/* Pack 2: Pack Profesional */}
          <div className="bg-[#1E3A8A] rounded-2xl overflow-hidden border-2 border-yellow-500/50 shadow-xl flex flex-col" data-id="element-143">
            <div className="bg-yellow-500 text-black text-center py-2 text-xs font-black uppercase tracking-widest" data-id="element-144">
              🏆 PACK PROFESIONAL
            </div>
            <div className="p-6 flex flex-col" data-id="element-145">
              <h3 className="text-lg font-black text-white text-center mb-1 leading-tight" data-id="element-146">
                Kit Comunicación y Oratoria + Sistema Completo de Taller de
                Escritura
              </h3>
              <p className="text-white/60 text-xs text-center mb-4" data-id="element-147">
                Combo docente premium
              </p>

              <div className="text-center mb-4" data-id="element-148">
                <p className="text-white/50 line-through text-sm" data-id="element-149">$69.990</p>
                <div className="flex justify-center items-baseline gap-1" data-id="element-150">
                  <span className="text-4xl font-black text-yellow-400" data-id="element-151">
                    $23.990
                  </span>
                  <span className="text-white/60 text-sm" data-id="element-152">ARS</span>
                </div>
              </div>

              <div className="flex justify-center mb-5" data-id="element-153">
                <img src={PACK_PRO_IMG} alt="Pack Profesional - Kit Comunicación y Oratoria + Taller de Escritura" className="w-full max-w-[280px] h-auto rounded-lg shadow-lg" data-id="element-154" />
              </div>

              <a href={CHECKOUT_SUPER} target="_blank" rel="noopener noreferrer" className="block w-full bg-[#D4A017] hover:bg-[#B8860B] text-white text-lg font-black py-3 rounded-lg shadow-lg text-center transition-all transform hover:-translate-y-1 mb-4" data-id="element-155">
                ✅ SÍ, QUIERO LA OFERTA →
              </a>

              <div className="space-y-2" data-id="element-156">
                {['Desarrollás argumentación escrita', 'Enseñás producción de textos con método', 'Tenés evaluación objetiva en oral y escrito', 'Ahorrás horas de planificación'].map((item, i) => <div key={i} className="flex items-center gap-2 text-sm text-white/90" data-id="element-157">
                    <CheckCircle2 className="w-4 h-4 text-[#D4A017] shrink-0" data-id="element-158" />
                    <span data-id="element-159">{item}</span>
                  </div>)}
              </div>

              <div className="flex justify-center items-center gap-3 text-white/40 text-xs mt-4" data-id="element-160">
                <span data-id="element-161">VISA</span>
                <span data-id="element-162">Mastercard</span>
                <span data-id="element-163">MercadoPago</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Preview Section */}
      <section id="preview-section" className="bg-[#F8FAFC] py-12 px-4 border-t border-gray-100" data-id="element-164">
        <div className="text-center mb-8" data-id="element-165">
          <span className="bg-amber-100 text-[#D4A017] px-4 py-1 rounded-full text-sm font-bold uppercase" data-id="element-166">
            Mirá por dentro
          </span>
          <h2 className="text-2xl font-bold text-[#1E3A8A] mt-3" data-id="element-167">
            <strong data-id="element-168">Páginas reales del</strong>{' '}
            <span className="text-[#2563EB]" data-id="element-169">material</span>
          </h2>
          <p className="text-gray-500 mt-1 text-sm" data-id="element-170">
            Proyectos paso a paso, clases listas y actividades prácticas
          </p>
        </div>
        <div className="max-w-3xl mx-auto relative" data-id="element-171">
          <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-200 cursor-pointer bg-white" onClick={scrollToPricing} data-id="element-172">
            <img src={PREVIEW_IMGS[previewIdx]} alt={`Página del material ${previewIdx + 1}`} className="w-full h-auto max-h-[500px] object-contain" data-id="element-173" />
          </div>
          <button onClick={prevPreview} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white border border-gray-200 shadow-md rounded-full p-2 hover:bg-gray-50 transition-colors" aria-label="Anterior" data-id="element-174">
            <ChevronLeft className="w-5 h-5 text-[#1E3A8A]" data-id="element-175" />
          </button>
          <button onClick={nextPreview} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white border border-gray-200 shadow-md rounded-full p-2 hover:bg-gray-50 transition-colors" aria-label="Siguiente" data-id="element-176">
            <ChevronRight className="w-5 h-5 text-[#1E3A8A]" data-id="element-177" />
          </button>
          <div className="flex justify-center gap-2 mt-4" data-id="element-178">
            {PREVIEW_IMGS.map((_, i) => <button key={i} onClick={() => setPreviewIdx(i)} className={`w-2.5 h-2.5 rounded-full transition-colors ${i === previewIdx ? 'bg-[#1E3A8A]' : 'bg-gray-300'}`} data-id="element-179" />)}
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-10 px-4 bg-white" data-id="element-180">
        <div className="max-w-3xl mx-auto bg-[#F8FAFC] border border-blue-100 rounded-xl p-6 flex flex-col md:flex-row items-center gap-5" data-id="element-181">
          <div className="bg-[#1E3A8A] p-4 rounded-full text-white shrink-0" data-id="element-182">
            <ShieldCheck className="w-9 h-9" data-id="element-183" />
          </div>
          <div data-id="element-184">
            <h3 className="text-lg font-bold text-[#16A34A] mb-1" data-id="element-185">
              🛡️ Garantía de Satisfacción Total
            </h3>
            <p className="text-[#0F172A] text-sm" data-id="element-186">
              Probalo <strong data-id="element-187">7 días</strong>. Si no cumple tus expectativas, te
              devolvemos el <strong data-id="element-188">100%</strong> de tu dinero. Sin preguntas,
              sin letra chica. Compra 100% protegida.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-14 px-4 bg-[#F8FAFC]" data-id="element-189">
        <h2 className="text-2xl font-bold text-center text-[#1E3A8A] mb-10" data-id="element-190">
          Testimonios de Docentes
        </h2>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-191">
          {[{
          name: 'María José G.',
          role: 'Docente de Secundaria · Buenos Aires',
          stars: 5,
          text: 'Jamás pensé que iba a organizar todo el año tan rápido. El material es increíble, las fichas son claras y los proyectos están listos para llevar al aula. ¡Lo recomiendo a todas mis colegas!'
        }, {
          name: 'Claudia R.',
          role: 'Profesora de Lengua · Córdoba',
          stars: 5,
          text: 'Mis alumnos mejoraron muchísimo su expresión oral. Las clases son más dinámicas y se nota que los chicos disfrutan participar. El sistema funciona de verdad.'
        }, {
          name: 'Sebastián M.',
          role: 'Docente de Comunicación · Rosario',
          stars: 4,
          text: 'Como docente de Comunicación, siempre me costó encontrar material de calidad. Este megapack me ahorró meses de trabajo. Los proyectos son excelentes y muy completos.'
        }, {
          name: 'Valeria T.',
          role: 'Profesora de Oratoria · Mendoza',
          stars: 5,
          text: 'Compré el Megapack y fue la mejor inversión del año. Tengo todo organizado, mis clases mejoraron notablemente y mis alumnos están más comprometidos.'
        }, {
          name: 'Diego F.',
          role: 'Docente · La Plata',
          stars: 4,
          text: 'Excelente material. Lo apliqué desde el primer día y los resultados fueron inmediatos. Los chicos participan más y yo perdí menos tiempo preparando. Vale cada peso.'
        }].map((t, i) => <div key={i} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" data-id="element-192">
              <div className="flex mb-3" data-id="element-193">
                {[...Array(5)].map((_, j) => <Star key={j} className={`w-4 h-4 ${j < t.stars ? 'fill-current text-yellow-400' : 'text-gray-200 fill-current'}`} data-id="element-194" />)}
              </div>
              <p className="text-[#0F172A] italic text-sm mb-4" data-id="element-195">"{t.text}"</p>
              <div data-id="element-196">
                <p className="font-bold text-[#0F172A] text-sm" data-id="element-197">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-198">{t.role}</p>
              </div>
            </div>)}
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 px-4 max-w-3xl mx-auto" data-id="element-199">
        <h2 className="text-2xl font-bold text-center text-[#1E3A8A] mb-8" data-id="element-200">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-3" data-id="element-201">
          {[{
          q: '¿En qué formato recibo el material?',
          a: '100% digital: PDF descargables listos para usar e imprimir.'
        }, {
          q: '¿Puedo imprimir los cuadernillos?',
          a: 'Sí, sin restricciones. Podés imprimir las copias que necesites para tus alumnos.'
        }, {
          q: '¿Para qué niveles sirve?',
          a: 'Principalmente para Nivel Secundario (Ciclo Básico y Orientado) y Talleres de Oratoria.'
        }, {
          q: '¿Cuánto tarda en llegar?',
          a: 'Acceso inmediato tras la compra. Te llega un email con el link de descarga.'
        }, {
          q: '¿Sirve para otros países?',
          a: 'Sí, los conceptos de oratoria y comunicación son universales, aunque está pensado con el currículo argentino en mente.'
        }].map((item, i) => <div key={i} className="bg-white p-5 rounded-lg border border-gray-100 shadow-sm" data-id="element-202">
              <div className="flex items-start gap-3" data-id="element-203">
                <div className="bg-[#1E3A8A] text-white w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold shrink-0 mt-0.5" data-id="element-204">
                  ?
                </div>
                <div data-id="element-205">
                  <h4 className="font-bold text-[#0F172A] mb-1 text-sm" data-id="element-206">
                    {item.q}
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-207">{item.a}</p>
                </div>
              </div>
            </div>)}
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-[#1E3A8A] text-white text-center" data-id="element-208">
        <div className="max-w-4xl mx-auto" data-id="element-209">
          <h2 className="text-2xl md:text-4xl font-extrabold mb-4" data-id="element-210">
            ¿Listo/a para transformar tu año escolar?
          </h2>
          <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-211">
            Uníte a cientos de docentes que ya organizaron su año sin estrés.
          </p>
          <button onClick={scrollToPricing} className="bg-[#D4A017] hover:bg-[#B8860B] text-white text-lg md:text-xl font-bold py-4 px-10 rounded-full shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center gap-2" data-id="element-212">
            <span data-id="element-213">✅</span> QUIERO EMPEZAR AHORA{' '}
            <ArrowRight className="w-5 h-5" data-id="element-214" />
          </button>
          <p className="mt-5 text-blue-200 text-sm" data-id="element-215">
            MEGA PACK COMUNICACIÓN Y ORATORIA™
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F172A] text-gray-400 py-10 px-4 text-center text-sm" data-id="element-216">
        <div className="max-w-4xl mx-auto" data-id="element-217">
          <div className="flex items-center justify-center gap-2 mb-3 text-white font-bold" data-id="element-218">
            <Zap className="w-4 h-4" data-id="element-219" /> MEGA PACK COMUNICACIÓN Y ORATORIA™
          </div>
          <p className="mb-3" data-id="element-220">
            © 2026 Mega Pack Comunicación. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-221">
            <a href="#" className="hover:text-white" data-id="element-222">
              Términos
            </a>
            <a href="#" className="hover:text-white" data-id="element-223">
              Privacidad
            </a>
            <a href="#" className="hover:text-white" data-id="element-224">
              Soporte
            </a>
          </div>
        </div>
      </footer>
    </div>;
}